import type { ReactElement } from 'react';
import type { FaqAccordionControllerProps } from '@application/components';

export interface MtFaqPageData {
  accordionComponent: ReactElement;
}

export interface MtFaqPageProps
  extends MtFaqPageData,
    Pick<FaqAccordionControllerProps, 'resource'> {}
